// JavaScript Document

// Scripts written by Jordan Bearce @ Weblinx, Inc.

import ScrollHint from "scroll-hint";

// init ScrollHint
new ScrollHint(".text__table__container, .wp-block-table");
